export const GET_PARTNERSHIPS_SUCCESS = 'GET_PARTNERSHIPS_SUCCESS';
export const GET_PARTNERSHIPS_FAILURE = 'GET_PARTNERSHIPS_FAILURE';
export const BREADCRUMB_SLICE = 'BREADCRUMB_SLICE';
export const BREADCRUMB_UPDATE_CURRENT_GROUP = 'BREADCRUMB_UPDATE_CURRENT_GROUP';
export const BREADCRUMB_PUSH = 'BREADCRUMB_PUSH';
export const UPDATE_ASIDE_ELMTS = 'UPDATE_ASIDE_ELMTS';
export const UPDATE_PARTNERS_GROUPS = 'UPDATE_PARTNERS_GROUPS';
export const SET_BREADCRUMBS = 'SET_BREADCRUMBS';
export const UPDATE_VIEW_CARD = 'UPDATE_VIEW_CARD';



// WEBPACK FOOTER //
// ./src/store/modules/partnerships/types.js